import { LocationStrategy } from '@angular/common';
import { Inject, Injectable, Optional } from '@angular/core';

import { LegalTextParser } from '../legal-text-parser/legal-text-parser';
import { EnumLegalInjectionToken, EnumLegalPageRoute, ILegalPagesConfig } from '../../../components/legal-pages/legal-pages.interface';


@Injectable()
export class LegalContentGenerator {

	constructor(
		@Inject(EnumLegalInjectionToken.Config)
		private legalPagesConfig: ILegalPagesConfig,
		private parser			: LegalTextParser,
		@Optional() private locationStrategy: LocationStrategy | null
	) {}

	generatePageContent(page: EnumLegalPageRoute, fallbackTemplate?: string): string {
		const document: string | undefined = this.legalPagesConfig.pageContent?.[page];
		if (!document) {
			if (!fallbackTemplate) throw new Error(`LegalContentGenerator => generatePageContent => No content provided for ${page}.`);
			return this.generateContent(fallbackTemplate);
		}

		return this.parser.parseDocument(document)
			.replace(/href="(\/legal\/[^"]*)"/g, (match: string, path: string) => `href="${this.locationStrategy?.prepareExternalUrl(path) ?? path}"`)
			.replace(/<table>/g, '<div class="legal-table-scroll" tabindex="0" role="region" aria-label="Legal information table"><table>')
			.replace(/<th>/g, '<th scope="col">')
			.replace(/<\/table>/g, '</table></div>');
	}

	generateContent<T extends object>(template: string, context?: T): string {

		//0 - check if config is provided
		if (!this.legalPagesConfig) throw new Error(`LegalContentGenerator => generateContent => FATAL ERROR: Config was not provided.`);

		//1 - parse markdown content
		const templateContent: string = this.parser.parse<T>({
			template	: template,
			context		: {
				...this.legalPagesConfig,
				...context || {} as T
			}
		});

		//2 - return parsed content
		return templateContent;
	}
}
